const LoadingController = require('LoadingController');
const LoadingBar = require('LoadingBar');
const GenericUI = require('GenericUI').ui;
const AudioMap = require('AudioMap');
const AudioManager = require('AudioManager');
const selectedConfig = require('LoadConfig');
const PSConfig = require('PSConfig');

cc.Class({
    extends: cc.Component,

    properties: {
        loadingController: LoadingController,
        loadingBar: LoadingBar,
        logo: cc.Node,
    },

    onLoad () {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
    },

    start () {
        this.loadingController.node.on('progress', (progress) => {
            this.loadingBar.updateProgress(progress);
        });

        this.loadingController.startLoading(selectedConfig);

        this.loadingController.node.on('loadingComplete', (data) => {
            // UPD: they requested to revert their shitty requirement
            // this.paytableUpdateForFin();

            this.nextSceneName = data.sceneName;
            GenericUI.enableCUIKeyboardKeysOnly(['Space', 'Enter']);
            GenericUI.enableCUIKeyboard();
            this.nextScene();
        });
    },

    paytableUpdateForFin () {
        /**
         * Stupid shitty workaround for s**** fin jurisdiction requirement
         */
        let { jurisdiction } = PSConfig.get();

        jurisdiction = jurisdiction.toString();
        jurisdiction = jurisdiction.toLowerCase();
        if (jurisdiction === 'fin') {
            cc.find('PSUIInitializer').
            getComponentInChildren('MenuController').
            paytablePage.
            getComponent('PaytablePageView').
            pageSelector.
            setData({ totalCount: 2, pageSize: 1 });
        }
    },

    onDestroy () {
        this.audioManager.stopMusic(this.audioID);
        GenericUI.enableCUIKeyboard(false);
    },

    nextScene () {
        this.loadingBar.hide().then(() => {
            // this.audioMap.audio.fadeOutMusic(500, this.audioID, true);
            const sc = this._getParentScale(this.logo);
            this.logo.setParentKeepPosition(this.node.parent);
            this.logo.scale = sc;
            cc.game.addPersistRootNode(this.logo);
            cc.director.loadScene(this.nextSceneName);
        });
    },

    _getParentScale (node) {
        if (node.parent) {
            return node.scale * this._getParentScale(node.parent);
        } else {
            return node.scale;
        }
    }
});
